import {
    CREATE_PURCHASE_BILL,
    DELETE_PURCHASE_BILL,
    GET_PURCHASE_BILLS,
    GET_PURCHASE_BILLS_PAGE,
    PURCHASE_BILL_REQUEST,
    PURCHASE_BILL_REQUEST_SUCCESS,
    PURCHASE_BILL_REQUEST_FAILURE,
    UPDATE_PURCHASE_BILL,
    GET_AVAILABLE_CHALLANS
  } from "../types/purchase-bill-types";
  
  const initialState = {
    purchaseBills: [],
    purchaseBillsPage: [],
    availableChallans: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const purchasebillReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_BILL_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_PURCHASE_BILLS: {
        return {
          ...state,
          purchaseBills: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_PURCHASE_BILLS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          purchaseBillsPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_PURCHASE_BILL: {
        return {
          ...state,
          purchaseBills: [action.payload, ...state.purchaseBills],
          loading: false,
          error: null
        };
      }
      case UPDATE_PURCHASE_BILL: {
        const purchaseBillsData = state.purchaseBills.slice(0);
        const uIndex = purchaseBillsData.findIndex((data) => data.id === action.payload.id);
        purchaseBillsData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          purchaseBills: [ ...purchaseBillsData ],
          loading: false,
          error: null
        };
      }
      case DELETE_PURCHASE_BILL: {
        const purchaseBills = state.purchaseBills?.slice(0);
        const index = purchaseBills.findIndex((data) => data.id === action.id);
        if (index > -1) {
          purchaseBills.splice(index, 1);
        }
        return {
          ...state,
          purchaseBills: [...purchaseBills],
          loading: false,
          error: null
        }
      }
      case PURCHASE_BILL_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case PURCHASE_BILL_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      case GET_AVAILABLE_CHALLANS: {
        return {
          ...state,
          availableChallans: [...action.payload],
          loading: false,
          error: null
        };
      }
      default:
        return state;
    }
  };
  
  export default purchasebillReducer;
  